export default __webpack_public_path__ + "static/media/app-ridestart.bc72bf9a.png";